import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 The K-Smart Visual System™ (6 Volumes, 120+ pages)',
  price: '$27'
}, {
  label: '🎁 Bonus #1: +100 Visual Korean Flashcards™',
  price: 'FREE'
}, {
  label: '🎁 Bonus #2: Hangul Express™ — Read Korean in 48h',
  price: 'FREE'
}, {
  label: '🎁 Bonus #3: K-Drama & K-Pop Phrases™ (50 expressions)',
  price: 'FREE'
}, {
  label: '🎁 Bonus #4: 30-Day Korean Challenge Calendar™',
  price: 'FREE'
}, {
  label: '🎁 Bonus #5: K-Smart Inner Circle (Private Discord)',
  price: 'FREE'
}, {
  label: '🛡️ 7-Day Money-Back Guarantee',
  price: 'INCLUDED'
}, {
  label: '♾️ Lifetime access & free updates',
  price: 'INCLUDED'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Delivery'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Debit / Credit'
}];
export function ValueStack() {
  return <section id="value" aria-label="Offer summary" className="border-y border-grape/10 bg-white/70" data-id="element-188" data-mp="1tfmn6mx4dn2e">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" data-id="element-189" data-mp="1oi37dikrx28c">
        <h2 className="font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-190" data-mp="2367tkwj1bvvv">
          🚀 Start Speaking Korean In 30 Days
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-plum/60" data-id="element-191" data-mp="1ycd3nbcu6koc">
          Read Hangul, pronounce properly and build your first real Korean sentences. One single
          payment, lifetime access, everything ready to start today.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-grape/15 bg-cream text-left" data-id="element-192" data-mp="2m4aeaz4jv6nv">
          <div className="flex items-center justify-between border-b border-grape/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-plum/55" data-id="element-193" data-mp="2h4o1urwjpug4">
            <span data-id="element-194" data-mp="rruccaiseeot">What's included</span>
            <span data-id="element-195" data-mp="mrpuag28dbwh">Price</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-grape/10 px-5 py-3.5 text-sm" data-id="element-196" data-mp="mt99e3c5hgwo">
              <span className="text-plum/80" data-id="element-197" data-mp="2rrqwkytq32k5">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-plum' : 'shrink-0 font-bold text-grape'} data-id="element-198" data-mp="2rud44ygm5i2d">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-col items-center gap-1 bg-lilac-soft px-5 py-6 text-center" data-id="element-199" data-mp="30u8kdhp10399">
            <span className="text-sm font-bold text-plum" data-id="element-200" data-mp="35rrx2d62s7z3">
              Real total value: <span className="text-plum/40 line-through" data-id="element-201" data-mp="3aptpvptazlnr">$129</span>
            </span>
            <span className="text-grape-shine font-display text-5xl font-black leading-none sm:text-6xl" data-id="element-202" data-mp="3fiwah8g3rkrt">
              $27
            </span>
            <span className="text-xs font-semibold uppercase tracking-wide text-plum/60" data-id="element-203" data-mp="3jlj4ng08xhs6">
              USD · One-time payment
            </span>
            <span className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-204" data-mp="3tgt9sclxy5a6">
              Payment will be processed in your local currency.
            </span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-205" data-mp="2hc2a2as7rsn">
          <CTAButton data-id="element-206" data-mp="2fr3u1lcjopi">🔥 Yes, I want instant access now</CTAButton>
        </div>

        <p className="mt-3 text-xs font-semibold text-plum/55" data-id="element-207" data-mp="3to4y0qmt2yps">
          You save $102 USD (79% OFF) · One-time payment
        </p>
        

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-208" data-mp="3po4mbdr3d1mf">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-209" data-mp="l9mvt5jjqde3">
              <Icon className="h-4 w-4 text-grape" data-id="element-210" data-mp="gfad4xpw963e" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}